export default "/static/build/boundly-logo-new.png";